/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { useState } from 'react';
import { ColumnFilter } from '../../../components/utr-modal/ColumnFilter';
import { ViewRadioButtons } from '../../../components/utr-modal/ViewRadioButtons';
import { ShowAs, UniversalTrackerModalServiceUtrv } from '../../../reducers/universal-tracker-modal';
import { canAddTarget } from '../../../utils/universalTracker';
import { ContentTabs, Tab } from '../../../components/utr-modal/ContentTabs';
import { ChartComponent } from '../../../components/utr-modal/components/chart';
import Dashboard, { DashboardRow } from '../../../components/dashboard';
import DataTable from '../../../components/utr-modal/components/data-table';
import { CollapsibleQuestionInfo } from '../../../components/utr-modal/CollapsibleQuestionInfo';
import { AdditionalInfo } from '../../../components/utr-modal/AdditionalInfo';
import UniversalTracker, { UniversalTrackerBase } from '../../../model/UniversalTracker';

interface UtrModalContainerProps {
  utr: UniversalTracker;
  utrvs: UniversalTrackerModalServiceUtrv[];
}

export const UtrModalBody = (props: UtrModalContainerProps) => {
  const { utr, utrvs } = props;

  const [selectedColumnCode, setColumnCode] = useState<undefined | string>(undefined);

  const utrPlain: UniversalTrackerBase = utr.getRaw();
  const canDrawChart = canAddTarget(utrPlain);

  const [activeTab, setActiveTab] = useState<Tab['navId']>(ShowAs.Chart);

  const viewTabs: Tab[] = [
    {
      navId: ShowAs.Chart,
      disabled: !canDrawChart,
      name: 'Chart',
      component: <ChartComponent utr={utr} utrvs={utrvs} selectedColumnCode={selectedColumnCode} />,
    },
    {
      navId: ShowAs.Table,
      name: 'Table',
      component: (
        <DashboardRow>
          <DataTable selectedColumnCode={selectedColumnCode} utr={utr} utrvs={utrvs} hideProvenance />
        </DashboardRow>
      ),
    },
  ];

  return (
    <Dashboard className='utr-modal-container'>
      <CollapsibleQuestionInfo utr={utr} />

      <DashboardRow mb={0}>
        <div className='w-100 d-flex justify-content-between align-items-center' style={{ height: '38px' }}>
          <ViewRadioButtons tabs={viewTabs} activeTab={activeTab} handleChangeTab={setActiveTab} />

          <ColumnFilter utr={utr} selectedColumnCode={selectedColumnCode} valueList={undefined} handleChangeColumn={setColumnCode} />
        </div>
      </DashboardRow>

      <ContentTabs tabs={viewTabs} activeTab={activeTab} />

      <AdditionalInfo utrPlain={utrPlain} />
    </Dashboard>
  );
};
